import { closePopupAction } from 'js/components/common/PopupManager/store/actions';

/**
 * Close notifications on multiple sessions. Use actionId or dialogId as track token and use it as popup id.
 * @param push
 * @param popups
 * @return {null|{payload: {id: *}, type: string}}
 */
export const notifyActionCloseNotification = (push, { popups }) => {
    const { actionId } = push.data;

    if (!actionId) {
        console.warn('Invalid push message', push);
        return null;
    }

    const popup = popups[actionId];

    return popup && !popup.isSyncClosed
        ? closePopupAction(actionId)
        : null;
};
